import { styled } from '@mui/material';

export const ParticipantRowRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  '&:not(:last-child)': {
    paddingBottom: '0.5rem',
    marginBottom: '0.5rem',
    borderBottom: `0.1rem solid ${theme.palette.divider}`,
  },
}));

export const ParticipantRowDescription = styled('div')({
  flexGrow: 1,
});

export const ParticipantHeading = styled('div')({
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  justifyContent: 'flex-start',
  gap: '0.5rem',
});

export const ParticipantName = styled('div')({
  marginRight: 'auto',
});

export const ParticipantRoles = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '0.5rem',
});
